import { Collapse as AntCollapse } from 'antd';
import React from 'react';
import styled from 'styled-components';

const { Panel } = AntCollapse;

const Collapse = styled(AntCollapse)`
  && {
    .ant-collapse-header {
      display: none;
    }
    && .ant-collapse-content-box {
      // remove the default indentation
      padding: 0px;
    }
  }
`;

export interface Props {
  children: React.ReactNode;
  condition?: boolean;
  style?: React.CSSProperties;
}

const UnstyledCollapse = ({ children, condition = false, style = {} }: Props) => (
  <Collapse activeKey={condition ? '1' : null} ghost destroyInactivePanel>
    <Panel key="1" style={style} header={null}>
      {children}
    </Panel>
  </Collapse>
);

export default UnstyledCollapse;
